// extracted by mini-css-extract-plugin
module.exports = {"page404Container":"page404-styles_page404Container__29YoW","photo":"page404-styles_photo__8FSTx","travolta":"page404-styles_travolta__3OfsD"};